import { PacsDtoKeysEnum } from '@zaoblako/shared/modules/pacs/enums/pacs-dto-keys.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { IronLogicConverterModeEnum } from '@zaoblako/shared/modules/pacs/enums/iron-logic-converter-mode.enum';

import * as yup from 'yup';

/** Converter set timezone request body */
export interface ConverterTimeZoneSingleFormInterface {
  /** Start time of the converter time zone (for example: “00:00”) */
  begin: string;
  /** End time of the converter time zone (for example: “23:59”) */
  end: string;
  /** Current device mode */
  mode: IronLogicConverterModeEnum;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
}

export interface ConverterTimezoneFormInterface {
  NORMAL: ConverterTimeZoneSingleFormInterface;
  LOCKED: ConverterTimeZoneSingleFormInterface;
  PASS_FREE: ConverterTimeZoneSingleFormInterface;
  PASS_FREE_PENDING: ConverterTimeZoneSingleFormInterface;
}

/** Converter set timezone request body - DTO schema */
export const ConverterTimeZoneSingleFormDto = SerdeDtoClass.create<ConverterTimeZoneSingleFormInterface>(PacsDtoKeysEnum.CONVERTER_TIMEZONE_SINGLE_FORM_DTO, {
  begin: {
    label: 'Дата начала',
    serializer: yup.string().matches(/^(2[0-3]|[01]?[0-9]):[0-5][0-9]$/, 'Некорректный формат времени'),
  },
  end: {
    label: 'Дата окончания',
    serializer: yup.string().matches(/^(2[0-3]|[01]?[0-9]):[0-5][0-9]$/, 'Некорректный формат времени'),
  },
  mode: {
    optional: true,
    label: 'Режим работы',
    serializer: yup
      .string()
      .oneOf(Object.values(IronLogicConverterModeEnum)),
  },
  monday: {
    label: 'Понедельник',
    serializer: yup.boolean(),
  },
  tuesday: {
    label: 'Вторник',
    serializer: yup.boolean(),
  },
  wednesday: {
    label: 'Среда',
    serializer: yup.boolean(),
  },
  thursday: {
    label: 'Четверг',
    serializer: yup.boolean(),
  },
  friday: {
    label: 'Пятница',
    serializer: yup.boolean(),
  },
  saturday: {
    label: 'Суббота',
    serializer: yup.boolean(),
  },
  sunday: {
    label: 'Воскресенье',
    serializer: yup.boolean(),
  },
});

export const ConverterTimeZoneFormDto = SerdeDtoClass.create<ConverterTimezoneFormInterface>(PacsDtoKeysEnum.CONVERTER_TIMEZONE_FORM_DTO, {
  NORMAL: {
    label: 'Режим Норма',
    nested: PacsDtoKeysEnum.CONVERTER_TIMEZONE_SINGLE_FORM_DTO,
    serializer: (_, nested) => nested,
  },
  LOCKED: {
    label: 'Режим Блокировка',
    nested: PacsDtoKeysEnum.CONVERTER_TIMEZONE_SINGLE_FORM_DTO,
    serializer: (_, nested) => nested,
  },
  PASS_FREE: {
    label: 'Режим Свободный',
    nested: PacsDtoKeysEnum.CONVERTER_TIMEZONE_SINGLE_FORM_DTO,
    serializer: (_, nested) => nested,
  },
  PASS_FREE_PENDING: {
    label: 'Режим Ожидание',
    nested: PacsDtoKeysEnum.CONVERTER_TIMEZONE_SINGLE_FORM_DTO,
    serializer: (_, nested) => nested,
  },
});
